@if (rows$ | async; as rows) {
  <div class="layout-col full">
    <div class="flex layout-col">
      <elder-table class="flex" dense [data]="rows">
        <!-- name Column -->
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef class="cell-10">
            {{ 'context.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.name }}</td>
        </ng-container>
        <!-- items Column -->
        <ng-container matColumnDef="items">
          <th mat-header-cell *matHeaderCellDef class="cell-10">
            {{ 'context.items' | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.itemCount }}</td>
        </ng-container>
        <!-- weight Column -->
        <ng-container matColumnDef="weight">
          <th mat-header-cell *matHeaderCellDef class="cell-10">
            {{ 'context.weight' | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.weight | elderQuantity }}</td>
        </ng-container>
        <!-- pieces Column -->
        <ng-container matColumnDef="pieces">
          <th mat-header-cell *matHeaderCellDef class="cell-10">
            {{ 'context.pieces' | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.quantities[Unit.pc]?.value || '-' }}</td>
        </ng-container>
      </elder-table>
    </div>
  </div>
}
